var _a;
import CardImg from "../../assets/images/paymentMethods/Card";
import KPayImg from "../../assets/images/paymentMethods/Kpay";
import CashImg from "../../assets/images/paymentMethods/Cash";
import TransferImg from "../../assets/images/paymentMethods/Transfer";
export var PaymentMethodsImgEnum;
(function (PaymentMethodsImgEnum) {
    PaymentMethodsImgEnum["CARD"] = "card";
    PaymentMethodsImgEnum["KPAY"] = "kpay";
    PaymentMethodsImgEnum["CASH"] = "cash";
    PaymentMethodsImgEnum["TRANSFER"] = "transfer";
})(PaymentMethodsImgEnum || (PaymentMethodsImgEnum = {}));
export var PAYMENT_IMGS = (_a = {},
    _a[PaymentMethodsImgEnum.CARD] = CardImg,
    _a[PaymentMethodsImgEnum.KPAY] = KPayImg,
    _a[PaymentMethodsImgEnum.CASH] = CashImg,
    _a[PaymentMethodsImgEnum.TRANSFER] = TransferImg,
    _a);
